<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row>
          <el-col :span="4" class="cls-col">
            <el-form-item label="所属资源分类" :inline="true" prop="id" >
              <el-select v-model="searchData.id" placeholder="所属资源分类" size="small" style="width: 100%" clearable>
                  <el-option
                  v-for="item in categoryData"
                  :key="item.resourceCategoryName"
                  :label="item.resourceCategoryName"
                  :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="视频名称" prop="resourceName" class="cls-col">
              <el-input v-model="searchData.resourceName" placeholder="视频名称" size="small" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="关键字" prop="keyWords" class="cls-col">
              <el-input v-model="searchData.keyWords" placeholder="如有多个关键字，请用；隔开" size="small" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
        </el-form-item>
      
      </el-form>
      <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addresources" class="but-cls">
        上传视频
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteResourcesMore" class="but-cls">删除
      </el-button>
      <el-button type="success" icon="el-icon-partly-cloudy" size="small" round @click="addresources" class="but-cls">
        导入视频
      </el-button>
      <el-table
          :data="ResourcesData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="resourceName"
            fixed
            label="视频名称"
        >
        </el-table-column>
        <el-table-column
            prop="resourceCategoryId"
            fixed
            label="所属资源分类"
        >
            <template slot-scope="scope">
              <span v-if="scope.row.resourceCategoryId == item.id" v-for="item in categoryData" :key="item.id"> {{item.resourceCategoryName}}
              </span>
            </template>
        </el-table-column>
        <el-table-column
            prop="keyWords"
            fixed
            label="关键字"
        >
        </el-table-column>
        <el-table-column
            prop="duration"
            label="视频时长"
        >
        </el-table-column>
        <el-table-column
            prop="resourceSize"
            label="视频大小"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateResources(scope.row)">修改</el-button>
            <el-button @click="deleteResources(scope.$index, scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="showResources(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        ResourcesData: [],
        href: '',
        searchData: {
          size: 0,
          page: 1,
          resourceName: '',
          id:'',
          resourceCategoryId: '',
          status: '',
          resourceUrl:'',
          keyWords:'',
          createTimeStart: '',
          createTimeEnd: '',
          resourceType:2,
          createBy:'',
          orgCode: ''
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addresources() {
        this.$router.push({
          name: 'addresources',
          params: {'title': '添加资源！'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].id;
        }
      },
      updateResources(row) {
        this.$router.push({
          name: 'addresources',
          params: row
        });
      },
      showResources(row) {
        let url = row.resourceUrl;
        window.open(url, '_blank');
      },
      deleteResourcesMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条资源, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          multipleSelection.forEach((index, item) => {
            let params = {'id': index};
            https.fetchPost('/resources/deleteResourceInfo', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == '200') {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.search();
              } else {
                this.$message({
                  type: 'info',
                  message: '删除失败：' + msg
                });
              }
            }).catch(err => {
                  this.$message.error('网络异常！');
                }
            );
          console.log(index,item)
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteResources(index, row) {
        this.$confirm('此操作将删除该资源, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id : row.id,
          }
          https.fetchPost('/resources/deleteResourceInfo', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        this.searchData.resourceCategoryId = this.searchData.id;
        let params = this.searchData;
        console.log(params,'paramsparams');
        https.fetchPost('/resources/getAllResourceList', params, 'json').then((data) => {
         
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.ResourcesData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },

      loadResourceCategory() {
        console.log(this.$store.state.token);
        this.categoryData = [];
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        https.fetchPost('resources/getCategoryList', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              this.categoryData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeOrg() {
        this.searchCourseType();
        this.searchData.ccId = '';
        this.loadResourceCategory();
        this.searchData.resourceCategoryId = "";
      },
      loadOrganization() {
        let params = {};
        https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            let d = data.data.data;
            if(data.data.data) {
              this.organizationData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.loadResourceCategory();
      this.loadOrganization();
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
